import React, { useEffect, useState } from 'react';
import Footer from "../../../Components/Footer/footer";
import { useParams } from 'react-router';
import { CustomErrorResponse } from '../../../CustomComponent/custom_error_response';
import { Toast } from '../../../CustomComponent/toast';
import performRequest from '../../../api/request';
import StepRoutes from "../../../Routes/steps_routes";
import { PiListFill} from "react-icons/pi"

const ViewMarketingClient = () => {
  const [data, setData] = useState({});
  const { id } = useParams();

  useEffect(() => {
    performRequest(
      "GET", (`marketingList/getMlById/${id}`)
    ).then((res) => {
      if (res.status === 200) {
        setData(res.data);
      } else {
        Toast("error", "Error while getting Quotations!");
      }
    })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [id]);

  const renderData = () => {
    return Object.keys(data).map((key, index) => (
      <tr key={index}>
        <th>{key.replace(/([A-Z])/g, ' $1').toUpperCase()}</th>
        <td>{data[key] || "Not Available"}</td>
      </tr>
    ));
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title"> <PiListFill className="fs-2 me-1"  style={{ color: "green" }} /> Marketing Data</h2>
                  <h4 className="text-muted">
                    {/* Client Details */}
                    <StepRoutes /> 
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Client Information</h5>
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">Field</th>
                            <th scope="col">Details</th>
                          </tr>
                        </thead>
                        <tbody>
                          {renderData()}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewMarketingClient;
